"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var ViewIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M11.9998774,7 C8.17286863,7 4.95374952,9.23346838 4,11.8 C4.95374952,14.3665316 8.17286863,16.6 11.9998774,16.6 C15.8268863,16.6 19.0460054,14.3665316 20,11.8 C19.0460054,9.23346838 15.8268863,7 11.9998774,7 Z M11.9998774,15.2475614 C10.104144,15.2475614 8.56701647,13.7038515 8.56701647,11.8 C8.56701647,9.89590235 10.104144,8.35243859 11.9998774,8.35243859 C13.8961011,8.35243859 15.4329835,9.89590235 15.4329835,11.8 C15.4329835,13.7038515 13.8961011,15.2475614 11.9998774,15.2475614 Z M11.9998774,9.60296425 C10.7919418,9.60296425 9.81220988,10.5866455 9.81220988,11.8 C9.81220988,13.0136007 10.7919418,13.9972819 11.9998774,13.9972819 C13.2078131,13.9972819 14.1877901,13.0136007 14.1877901,11.8 C14.1877901,10.5866455 13.2078131,9.60296425 11.9998774,9.60296425 Z" }))); };
exports.ViewIcon = ViewIcon;
